import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ContactSummaryFragment,
    GetContactSummary as GetContactSummaryQuery,
    GetContactSummaryVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT_SUMMARY from '../queries/get-contact-summary.graphql';

export function useGetContactSummary(
    contactId: string,
    skip: boolean = false
): {
    contactSummary: ContactSummaryFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetContactSummaryQuery,
        GetContactSummaryVariables
    >(GET_CONTACT_SUMMARY, {
        variables: {id: contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        contactSummary: data?.contact ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
